module.exports = __webpack_public_path__ + "img/logo.423bf227.png";